import {
  jb_button_back_css_default
} from "./chunk.4LNQCWDY.js";
import {
  Rt
} from "./chunk.LQ2ZH6PS.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  ke,
  r
} from "./chunk.WKUNRGJV.js";
import {
  n
} from "./chunk.LWNTGWZJ.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-button-back/jb-button-back.ts
var JbButtonBack = class extends r {
  render() {
    return ke`
      <span class="${Rt({ white: this.isWhite })}">
        <jb-arrow-back-icon></jb-arrow-back-icon>
        <span>${this.text}</span>
      </span>
    `;
  }
};
JbButtonBack.styles = jb_button_back_css_default;
__decorateClass([
  n({ type: Boolean })
], JbButtonBack.prototype, "isWhite", 2);
__decorateClass([
  n()
], JbButtonBack.prototype, "text", 2);
JbButtonBack = __decorateClass([
  customElement("jb-button-back")
], JbButtonBack);

export {
  JbButtonBack
};
